




























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { userUserGroupsFields } from "@/components/users/fields/userUserGroupsFields";
import SelectUserGroupModal from "@/components/users/modals/SelectUserGroupModal.vue";
import { UserGroup } from "@/services/users/types";
import { getUserGroupsForUser } from "@/services/users/userGroupService";
import UserUserGroupDeleteModal from "@/components/users/modals/UserUserGroupDeleteModal.vue";
@Component({
    components: { UserUserGroupDeleteModal, SelectUserGroupModal }
})
export default class UserUserGroups extends Vue {
        @Prop() userId!: string;
        @Prop() collapseState!: boolean;

        // local state
        localUserId = "";
        userGroups = [] as UserGroup[];
        searchQuery = "";
        fields = userUserGroupsFields;
        localCollapseState = true;

    // watchers
    @Watch("userId")
        onPropertyChanged() {
            this.localUserId = this.userId;
            this.localCollapseState = this.collapseState;
            this.fetchData();
        }

    // computed
    get filteredData() {
        return this.userGroups && this.userGroups
            .filter(x => this.searchQuery.length === 0 ||
                (x.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
                    x.description.toLowerCase().includes(this.searchQuery.toLowerCase())));
    }

    // methods
    fetchData() {
        getUserGroupsForUser(this.userId).then(response => {
            this.userGroups = response;
            this.$emit("initUserGroups", this.userGroups.map(x => x.id));
        });
    }

    setState(state:boolean) {
        if (this.localCollapseState === state) return;

        this.localCollapseState = state;
        this.$emit("componentStateChanged", { name: "UserUserGroups", state: state });
    }

    openUserGroupsPrompt() {
        (this.$refs.selectUserGroup as any).open(true);
    }

    onUserGroupSelected(userGroups: UserGroup[]) {
        const userGroupsToBeAdded = userGroups
            .filter(x => !this.userGroups.map(x => x.id).includes(x.id));
        if (userGroupsToBeAdded.length > 0) {
            this.userGroups = this.userGroups.concat(userGroupsToBeAdded);
        }
    }

    removeUserGroup(userGroup: UserGroup) {
        (this.$refs.deleteUserGroup as any).open(userGroup.id, userGroup.name);
    }

    onDeleted(id: string) {
        const item = this.userGroups.find(x => x.id === id);
        if (!item) {
            return;
        }
        this.userGroups = this.userGroups.filter(x => x.id !== id);
    }

    emitData() {
        this.$emit("userGroupsUpdated", this.userGroups.map(x => x.id));
    }
}
